jQuery(document).ready(function($) {

	'use strict';

	// Foundation block: video height follows .microbiome-foundation-content (layout + resize)
	function syncMicrobiomeFoundationVideoHeight() {
		$('.microbiome-foundation-section').each(function () {
			var $section = $(this);
			var $content = $section.find('.microbiome-foundation-content').first();
			var $video = $section.find('video').first();
			if (!$content.length || !$video.length) return;
			var h = Math.ceil($content.outerHeight());
			if (h > 0) {
				$video.css('height', h + 'px');
			}
		});
	}

	syncMicrobiomeFoundationVideoHeight();
	$(window).on('load', syncMicrobiomeFoundationVideoHeight);
	var foundationResizeTimer;
	$(window).on('resize orientationchange', function () {
		clearTimeout(foundationResizeTimer);
		foundationResizeTimer = setTimeout(syncMicrobiomeFoundationVideoHeight, 50);
	});
	if (window.ResizeObserver) {
		$('.microbiome-foundation-content').each(function () {
			var ro = new ResizeObserver(function () {
				syncMicrobiomeFoundationVideoHeight();
			});
			ro.observe(this);
		});
	}

    jQuery('.serum-step-info-img-mobile1').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        infinite: true,
        centerMode: false,
        dots: true,
        arrows:true,
        prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><img src="assets/images/arrow.svg" alt="Previous" /></button>',
        nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><img src="assets/images/arrow.svg" alt="Next" /></button>',
        autoplaySpeed: 5000,
        fade: false,
        cssEase: 'linear',
    });

    jQuery('.horiz-gallery-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        infinite: true,
        centerMode: false,
        dots: false,
        arrows:true,
        prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><img src="assets/images/arrow.svg" alt="Previous" /></button>',
        nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><img src="assets/images/arrow.svg" alt="Next" /></button>',
        autoplaySpeed: 5000,
        fade: false,
        cssEase: 'linear',
    });
});